// extracted by css-extract-rspack-plugin
export default {"addButton":"AddEmployeeSurvey__addButton--EztqV","disabledButton":"AddEmployeeSurvey__disabledButton--eO3xT"};